import { OdataManager } from '@/api/odata/odata-manager';
import { Reftable } from '@/api/model/interfaces';

export default class ReftableOdata extends OdataManager<Reftable> {}
